import { render } from "./ShipmentsPage.vue?vue&type=template&id=4ebd61fa&scoped=true"
import script from "./ShipmentsPage.vue?vue&type=script&lang=js"
export * from "./ShipmentsPage.vue?vue&type=script&lang=js"

import "./ShipmentsPage.vue?vue&type=style&index=0&id=4ebd61fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebd61fa"]])

export default __exports__